import HTTP from './http.service';
class OrderService {
  static createOrder(data) {
    const config = {
      method: 'post',
      url: `/support/submitM2MOrder`,
      data: data,
    };
    return HTTP(config);
  }
  static updateOrder(data) {
    const config = {
      method: 'post',
      url: `/support/updateM2MOrder`,
      data: data,
    };
    return HTTP(config);
  }
  static getM2MBundlesPrices() {
    const config = {
      method: 'get',
      url: `/support/getM2MBundlesPrices`,
    };
    return HTTP(config);
  }
  static getM2MSIMPrices() {
    const config = {
      method: 'get',
      url: `/support/getM2MSIMPrices`,
    };
    return HTTP(config);
  }
  static contactExpert(data) {
    const config = {
      method: 'post',
      url: `/support/contactExpert`,
      data: data,
    };
    return HTTP(config);
  }
  static pushToTalk(data) {
    const config = {
      method: 'post',
      url: `/support/pushTotalk`,
      data: data,
    };
    return HTTP(config);
  }

  static getOrderSmsDetails(orderId, token) {
    const config = {
      method: 'get',
      url: `/airalo/public-order?code=${orderId}`,
      headers: {
        Authorization: token,
      },
    };
    return HTTP(config);
  }

}

export default OrderService;
